'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  activateText: 'Refresh immediately after release',
  deactivateText: 'Pull down to refresh',
  finishText: 'Finish refresh'
};
module.exports = exports['default'];